import React from 'react';
import styled from 'styled-components';

import { ICON_TYPES } from '../../../../shared/constants';

import { ArrowRight } from '../../../atoms/icons/ArrowRight';
import { ChevronRightLarge } from '../../../atoms/icons/ChevronRightLarge';
import { ExternalIcon } from '../../../atoms/icons/ExternalIcon';

interface Props {
  iconType: string;
}

const LinkIcon = ({ iconType = ICON_TYPES.arrow }: Props) => {
  const renderIcon = () => {
    switch (iconType) {
      case ICON_TYPES.arrowLarge:
        return <ChevronRightLarge />;
      case ICON_TYPES.external:
        return <ExternalIcon />;
      case ICON_TYPES.arrow:
      default:
        return <ArrowRight />;
    }
  };

  return <StyledIcon>{renderIcon()}</StyledIcon>;
};

export default LinkIcon;

const StyledIcon = styled.div`
  display: inline-flex;
  margin-right: 4px;
  transition: transform 0.15s ease;
`;
